import { Directive, Input, OnInit, ElementRef } from '@angular/core';

import { LoginService } from './../services/login.service';
import { AccountService } from '@services/account.service';

@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: '[ingsvAdmRoleAllowed]'
})
export class RoleDirective implements OnInit {
  @Input() ingsvAdmRoleAllowed: any;

  constructor(
    private elementRef: ElementRef,
    private accountService: AccountService,
    private loginService: LoginService
  ) { }

  ngOnInit(): void {
    if (this.loginService.isLoggedIn) {
      if (this.ingsvAdmRoleAllowed.length) {
        if (!this.ingsvAdmRoleAllowed.includes(this.accountService.profileData.roleId)) {
          this.elementRef.nativeElement.remove();
        }
      } else if (!this.ingsvAdmRoleAllowed.length) {
        if (this.ingsvAdmRoleAllowed !== this.accountService.profileData.roleId) {
          this.elementRef.nativeElement.remove();
        }
      }
    }
  }
}
